/* eslint-disable */
import React from 'react';

const SectionTitle = ({ title }) => {
  return (
    <>
      <h3 className="text-center">
        <b>{title}</b>
      </h3>
      <hr />
    </>
  );
};

export default SectionTitle;
